<template>
	<div class="page">
		<div class="content">
			<el-card v-for="doc in docs" class="card">
				<div slot="header" @click="open(doc.url)" class="header">
					<span>{{doc.title}}</span>
				</div>
				{{doc.text}}
			</el-card>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				docs: [{
						title: " IDE介绍",
						text: "介绍了IDE的基本情况、下载、安装和使用",
						url: "http://ide.rosc.org.cn/help/ide.pdf",
					},
					{
						title: "Blockly封装模块",
						text: "介绍Blockly模块封装的流程",
						url: "http://ide.rosc.org.cn/help/blockly.pdf",
					},
					{
						title: "SIA_RCS_OS.img系统镜像使用",
						text: "实时系统新装配置",
						url: "http://ide.rosc.org.cn/help/linux.pdf",
					}
				]
			}
		},
		methods: {
			open(url) {
				window.open(url)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		@include flex;

		.content {
			margin-top: $nav-bar-height;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-evenly;
			width: 80%;

			.card {
				width: 300px;

				.header:hover {
					cursor: pointer;
				}
			}
		}
	}
</style>
